import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";

// Import your components here
import { gql, useQuery } from "@apollo/client";
import StorageService from "../utils/storage";
import Home from "../pages/Home";
import EventsSingle from "../pages/EventsSingle";
//import Privacy from "../pages/Privacy";
import TwoColumnWithSidebar from "../pages/TwoColumnWithSidebar";
import TwoColumnWithForm from "../pages/TwoColumnWithForm";
import TwoColumn from "../pages/TwoColumn";
import OneColumnWithMap from "../pages/OneColumnWithMap";
import TwoColumnWithFormAndSidebar from "../pages/TwoColumnWithFormAndSidebar";
import PictonEmbeds from "../pages/PictonEmbeds";
import StudentTravel from "../pages/StudentTravel";
import DynamicList from "../pages/DynamicList";
import NotFound from "../pages/NotFound";
import Loading from "../pages/Loading";
import TimetablesRedirect from "../components/TimetableRedirect";
import OneColumn from "../pages/OneColumn";
import SchoolList from "../pages/SchoolList";
import FreeSchoolTravel from "../pages/SchoolTravel";
import TicketingAndFares from "../pages/TicketingAndFares";


const menuQuery = gql`
    query getMenu($id: String) {
        wbMenus(filters: { organisation: { orgId: { eq: $id } } }) {
            data {
                id
                attributes {
                    menu {
                        ... on ComponentWbMenusMenu {
                            name
                            url
                            page {
                                data {
                                    id
                                    attributes {
                                        type {
                                            __typename
                                        }
                                    }
                                }
                            }
                        }
                        ... on ComponentWbMenusSubmenu {
                            name
                            url
                            page {
                                data {
                                    id
                                    attributes {
                                        type {
                                            __typename
                                        }
                                    }
                                }
                            }
                            menu {
                                name
                                url
                                page {
                                    data {
                                        id
                                        attributes {
                                            type {
                                                __typename
                                            }
                                        }
                                    }
                                }
                                menu {
                                    name
                                    url
                                    page {
                                        data {
                                            id
                                            attributes {
                                                type {
                                                    __typename
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

const AppRouter = () => {
    const [routes, setRoutes] = useState([]);
    const { data } = useQuery(menuQuery, {
        variables: {
            id: StorageService.getItem("organisationBusableId"),
        },
    });

    useEffect(() => {
        if (data) {
            // const menu = data.wbMenus.data[0].attributes.menu;
            const menu = [];
            data.wbMenus.data.forEach((item) => item.attributes.menu.forEach((subItem) => menu.push(subItem)));
            console.log(menu);
            // generate flat map of all routes with urls defined (children including)
            const items = [];

            const handleDynamicPage = (item) => {
                items.push(
                    ...[
                        {
                            url: item.url,
                            type: "dynamicList",
                            pageId: item.page?.data?.id,
                        },
                        {
                            url: `${item.url}/:id`,
                            type: "dynamicItem",
                            pageId: item.page?.data?.id,
                        },
                    ]
                );
            };
            menu.forEach((item) => {
                if (item.__typename === "ComponentWbMenusMenu") {
                    const type = item.page?.data?.attributes?.type[0]?.__typename;
                    if (type === "ComponentLayoutsPosts") {
                        handleDynamicPage(item);
                    } else {
                        items.push({
                            url: item.url,
                            type,
                            pageId: item.page?.data?.id,
                        });
                    }
                } else if (item.__typename === "ComponentWbMenusSubmenu") {
                    return item.menu.map((subItem) => {
                        const type = subItem.page?.data?.attributes?.type[0]?.__typename;

                        if (subItem.url) {
                            if (type === "ComponentLayoutsPosts") {
                                handleDynamicPage(subItem);
                            } else {
                                items.push({
                                    url: subItem.url,
                                    type,
                                    pageId: subItem.page?.data?.id,
                                });
                            }
                        }
                        subItem.menu.map((subSubItem) => {
                            const type = subSubItem.page?.data?.attributes?.type[0]?.__typename;
                            if (subSubItem.url) {
                                if (type === "ComponentLayoutsPosts") {
                                    handleDynamicPage(subSubItem);
                                } else {
                                    items.push({
                                        url: subSubItem.url,
                                        type,
                                        pageId: subSubItem.page?.data?.id,
                                    });
                                }
                            }
                        });
                    });
                }
            });
            setRoutes(items.filter(e => e.pageId !== undefined && e.pageId !== null));
        }
    }, [data]);

    const getElementByType = (type, pageId, url) => {
        switch (type) {
            case "ComponentLayoutsTwoColumnWithFormAndSidebar":
                return <TwoColumnWithFormAndSidebar pageId={pageId} />;
            case "ComponentLayoutsTwoColumnWithForm":
                return <TwoColumnWithForm pageId={pageId} />;
            case "ComponentLayoutsTwoColumn":
                return <TwoColumn pageId={pageId} />;
            case "ComponentLayoutsTwoColumnWithSidebar":
                return <TwoColumnWithSidebar pageId={pageId} />;
            case "ComponentLayoutsOneColumnWithMap":
                return <OneColumnWithMap pageId={pageId} />;
                case "ComponentLayoutsOneColumn":
                    return <OneColumn pageId={pageId} />;
            case "ComponentLayoutsHomepage":
                return <Home pageId={pageId} />;
            case "dynamicList":
                return <DynamicList pageId={pageId} url={url} />;
            case "dynamicItem":
                return <EventsSingle />;
            default:
                return <NotFound />;
        }
    };

    // Hard coded routes that cant be dynamically generated for now.
    const skipGenerationArray = [
        "/trip-planner-timetables",
        "/school-trip-planner-timetables",
        "/fares-and-concessions",
        "/ticketing-and-fares",
        "/free-school-travel",
        "/privacy",
        "/policies",
        "/sitemap",
        "/links",
    ];

    return (
        <Routes>
            {routes
                .filter((r) => !skipGenerationArray.includes(r.url))
                .map((route) => {
                    return (
                        <Route path={route.url} element={getElementByType(route.type, route.pageId, route.url)} exact={route.url === "/"} />
                    );
                })}
                {console.log(routes)}
            <Route path="/trip-planner-timetables" element={<PictonEmbeds />} />
            <Route path="/school-trip-planner-timetables" element={<PictonEmbeds />} />
            <Route path="/fares-and-concessions" element={<StudentTravel />} />
            <Route path="/ticketing-and-fares" element={<TicketingAndFares />} />
            <Route path="/free-school-travel" element={<FreeSchoolTravel />} />
            <Route path="/events" element={<DynamicList />} />
            <Route path="/events/:id" element={<EventsSingle />} />
            {routes.length ? <Route path="*" element={<NotFound />} /> : <Route path="*" element={<Loading />} />}
        </Routes>
    );
};

export default AppRouter;
